module.exports = __webpack_public_path__ + "img/wordImg.fd47bd46.png";